import { FlexContainer } from '@act/storybook';
import type { PropsWithChildren } from 'react';

interface ReportsSurfaceProps extends PropsWithChildren {
  padding?: number;
  /** When set, fixes card width instead of stretching to the parent row. */
  width?: string;
  height?: string;
  flexShrink?: number;
}

/**
 * White card surface for filters, tables, and empty states on the reports subdomain.
 * @param padding - Inner padding multiplier (theme spacing units).
 * @param width - Optional fixed width (e.g. builder sidebar).
 * @param height - Optional fixed height (e.g. builder sidebar fill).
 * @param flexShrink - Flex shrink factor; use 0 for fixed-width sidebars.
 */
const ReportsSurface = ({
  children,
  padding = 2,
  width,
  height,
  flexShrink,
}: ReportsSurfaceProps) => {
  return (
    <FlexContainer
      direction="column"
      width={width ?? '100%'}
      height={height ?? 'auto'}
      flexShrink={flexShrink}
      overflowAllVisible={true}
      padding={padding}
      backgroundColor="#ffffff"
      border="1px solid rgba(0, 0, 0, 0.08)"
      borderRadius="slightlyRounded"
    >
      {children}
    </FlexContainer>
  );
};

export default ReportsSurface;
